export default "__VITE_ASSET__CHsJ0mi0__"